import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { checklistInterface, checklistTopic } from 'src/app/util/interfaces/checklist';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ChecklistRegisterPageService } from './service/checklist-register-page.service';
import { forkJoin, from } from 'rxjs';
import { faHand, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { solutionAreaInterface } from 'src/app/util/interfaces/requestClassification';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-checklist-register-page',
	standalone: true,
	imports: [CommonModule, RouterModule, GenericFormGenModule, FontAwesomeModule, DotBounceLoadingEffectModule],
	templateUrl: './checklist-register-page.component.html',
	styleUrl: './checklist-register-page.component.css',
})
export class ChecklistRegisterPageComponent implements OnInit {
	icons = {
		faPlus: faPlus,
		faTimes: faTimes,
		faHand: faHand,
	};

	labels: LabelsInterface = {
		lbl_checklist_criacao: '',
		lbl_checklist: '',
		lbl_geral_registrar: '',
		lbl_geral_informacoes: '',
		lbl_geral_informacoes_gerais: '',
		lbl_geral_nome: '',
		lbl_geral_procedimentos: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private ChecklistRegisterPageService: ChecklistRegisterPageService,
		private NotificationService: NotificationService,
		private ActivatedRoute: ActivatedRoute,
		private Router: Router
	) {}

	isLoadingLabels = true;
	isLoadingForm = true;
	isUpdatingChecklist = false;
	isDeletingChecklist = false;

	tabView = 'info';
	viewType: 'read' | 'edit' = 'edit';

	checklistRegister: checklistInterface;

	/* FORM */
	generalInformationForm: genericFormI[] = [];
	procedureForm: genericFormI[][] = [];
	procedureFormTemplate: genericFormI[];

	isDragging = false;
	draggingProcedureIndex: number = null;
	dragButtonPosition = { x: 0, y: 0 };
	/* END OF FORM */

	ngOnInit(): void {
		this.initChecklistRegister();
		this.ActivatedRoute.params.subscribe({
			next: (parameters) => {
				if (parameters && parameters.idChecklist) {
					this.checklistRegister.id = parameters.idChecklist;
				}
			},
		});

		this.LabelsService.getLabels()
			.subscribe({
				next: (labels) => {
					this.labels = labels;
				},
			})
			.add(() => {
				this.isLoadingLabels = false;
			});

		forkJoin([
			this.ChecklistRegisterPageService.getChecklistGeneralForm(),
			this.ChecklistRegisterPageService.getChecklistProcedureForm(),
			this.ChecklistRegisterPageService.getChecklistData(this.checklistRegister.id),
		])
			.subscribe({
				next: (forkRes) => {
					const generalInformationForm = forkRes[0];
					const procedureForm = forkRes[1];
					const checklistData = forkRes[2];

					this.generalInformationForm = generalInformationForm;
					this.procedureFormTemplate = procedureForm;
					this.procedureForm.push(JSON.parse(JSON.stringify(this.procedureFormTemplate)));

					for (const formItem of this.generalInformationForm) {
						this.generalFormToInterface(formItem);
					}
					for (const [index, procedure] of this.procedureForm.entries()) {
						for (const formItem of procedure) {
							this.procedureFormToInterface(formItem, index);
						}
					}

					if (checklistData != undefined) {
						this.checklistRegister = checklistData;
						if (this.checklistRegister.status == 'RUNNING') {
							this.NotificationService.setNotificationMessage(this.labels['lbl_edicao_bloqueada_checklist_execucao']);
							this.viewType = 'read';
						}
						this.interfaceToForm();
					}
				},
			})
			.add(() => {
				this.isLoadingForm = false;
			});
	}

	initChecklistRegister(): void {
		this.checklistRegister = {
			checklist_topic: null,
			name: '',
			description: '',
			status: '',
			enduser: null,
			registered_by: '',
			periodicity: '',
			expirationTime: null,
			solution_area: null,
			steps: [],
			active: 1,
		};
	}

	initProcedureAt(index: number): void {
		this.checklistRegister['steps'][index] = {
			procedure: '',
			inFailureNotifyUser: [],
			incidentTemplate: null,
			name: '',
			status: null,
		};
	}

	changeTab(tab: string) {
		this.tabView = tab;
	}

	generalFormToInterface(field: genericFormI): void {
		if (!(field.name in this.checklistRegister)) return;

		let value = field.rawValues[0];
		if (field.name == 'checklist_topic' && field.values[0]) {
			const selectedItem = field.items.find((item) => {
				return item.values[0].toString() == field.values[0].toString();
			});
			let topic: checklistTopic = undefined;
			if (selectedItem != undefined) {
				topic = {
					id: selectedItem.values[0],
					name: selectedItem.name,
				};
			}

			value = topic;
		}

		if (field.name == 'enduser' && field.values[0]) {
			const selectedItem = field.items.find((item) => {
				return item.values[0].toString() == field.values[0].toString();
			});
			let enduser: enduserInterface = undefined;
			if (selectedItem != undefined) {
				enduser = {
					id: selectedItem.values[0],
					fullName: selectedItem.name,
				};
			}

			value = enduser;
		}

		if (field.name == 'solution_area' && field.values[0]) {
			const selectedItem = field.items.find((item) => {
				return item.values[0].toString() == field.values[0].toString();
			});
			let solution_area: solutionAreaInterface = undefined;
			if (selectedItem != undefined) {
				solution_area = {
					id: selectedItem.values[0],
					name: selectedItem.name,
					label: selectedItem.label,
				};
			}

			value = solution_area;
		}

		if (field.name == 'periodicity' && field.values[0]) {
			const values = field.values[0].split(' ');
			const minute = values[0].split(',').sort((a, b) => {
				if (a > b) return 1;
				if (b > a) return -1;
				return 0;
			});
			values[0] = minute.join(',');
			field.values[0] = values.join(' ');
			field.rawValues = JSON.parse(JSON.stringify(field.values));
		}

		this.checklistRegister[field.name] = value;
	}

	procedureFormToInterface(field: genericFormI, procedureIndex: number): void {
		if (!this.checklistRegister['steps'][procedureIndex]) {
			this.initProcedureAt(procedureIndex);
		}
		if (!(field.name in this.checklistRegister['steps'][procedureIndex])) return;

		let value = field.rawValues[0];

		if (field.name == 'inFailureNotifyUser') {
			value = [];
			for (const fieldValue of field.values) {
				const temporaryUser: enduserInterface = {
					id: fieldValue.values[0],
					fullName: fieldValue.name,
				};
				value.push(temporaryUser);
			}
		}

		if (field.name == 'incidentTemplate' && field.values[0]) {
			const selectedItem = field.items.find((item) => {
				return item.values[0].toString() == field.values[0].toString();
			});
			const template: templateReworkInterface = {
				id: selectedItem.values[0],
				name: selectedItem.name,
				summary: selectedItem.name,
				description: '',
				informative: '',
			};
			value = template;
		}

		this.checklistRegister['steps'][procedureIndex][field.name] = value;
	}

	interfaceToForm(): void {
		for (const formItem of this.generalInformationForm) {
			if (formItem.name == 'checklist_topic') {
				formItem.values[0] = this.checklistRegister.checklist_topic.id;
			} else if (formItem.name == 'enduser') {
				formItem.values[0] = this.checklistRegister.enduser.id;
			} else if (formItem.name == 'solution_area') {
				formItem.values[0] = this.checklistRegister.solution_area.id;
			} else if (formItem.name == 'periodicity') {
				formItem.values = this.checklistRegister.periodicity.split(' ');
			} else formItem.values[0] = this.checklistRegister[formItem.name];
		}

		this.procedureForm = [];
		for (const step of this.checklistRegister.steps) {
			const temporaryProcedureForm = JSON.parse(JSON.stringify(this.procedureFormTemplate));
			for (const formItem of temporaryProcedureForm) {
				if (formItem.name == 'inFailureNotifyUser') {
					for (const user of step[formItem.name]) {
						const formUser = formItem.items.find((u) => {
							return u.values[0].toString() == user.id;
						});
						formItem.values.push(formUser);
						formItem.rawValues.push(formUser.values[0]);
					}
					// formItem.values = step[formItem.name].split(',').filter(i => i);
				} else if (formItem.name == 'incidentTemplate') formItem.values[0] = step.incidentTemplate.id;
				else formItem.values[0] = step[formItem.name];
			}
			this.procedureForm.push(temporaryProcedureForm);
		}
	}

	addStepToProcedure(): void {
		this.procedureForm.push(JSON.parse(JSON.stringify(this.procedureFormTemplate)));
		this.checklistRegister.steps.push({
			procedure: '',
			inFailureNotifyUser: [],
			incidentTemplate: null,
			name: '',
			status: null,
		});
	}

	removeStepFromProcedure(index: number): void {
		if (this.procedureForm.length <= 1) {
			this.NotificationService.setNotificationMessage('_O checklist precisa de pelo menos um passo');
			return;
		}
		this.procedureForm.splice(index, 1);
		this.checklistRegister.steps.splice(index, 1);
	}

	moveStepFromProcedure(fromStepIndex: number, toStepIndex: number): void {
		if (fromStepIndex == toStepIndex) return;
		const holdProcedure = this.procedureForm[fromStepIndex];
		const holdStep = this.checklistRegister.steps[fromStepIndex];
		this.procedureForm.splice(fromStepIndex, 1);
		this.procedureForm.splice(toStepIndex, 0, holdProcedure);

		this.checklistRegister.steps.splice(fromStepIndex, 1);
		this.checklistRegister.steps.splice(toStepIndex, 0, holdStep);
	}

	setDragButtonPosition(procedureFormBody: HTMLElement, me: MouseEvent): void {
		const rect = procedureFormBody.getBoundingClientRect();
		this.dragButtonPosition.x = me.clientX - rect.left + 4;
		this.dragButtonPosition.y = me.clientY - rect.top + 4;
	}

	createChecklist(): void {
		if (!this.checkFormValues() || this.isUpdatingChecklist == true) return;

		this.isUpdatingChecklist = true;
		this.ChecklistRegisterPageService.createChecklist(this.checklistRegister)
			.subscribe({
				next: (res) => {
					this.checklistRegister.id = res.data.id;
					for (const [index, step] of this.checklistRegister.steps.entries()) {
						step.id = res.data.step[index];
					}
					this.NotificationService.setNotificationMessage(this.labels['lbl_geral_criado_com_sucesso']);
				},
				error: () => {
					this.NotificationService.setNotificationMessage(this.labels['lbl_erro_tente_novamente']);
				},
			})
			.add(() => {
				this.isUpdatingChecklist = false;
			});
	}

	updateChecklist(): void {
		if (!this.checkFormValues() || this.isUpdatingChecklist == true || this.isDeletingChecklist == true) return;

		this.isUpdatingChecklist = true;
		this.ChecklistRegisterPageService.updateChecklist(this.checklistRegister)
			.subscribe({
				next: (res) => {
					for (const step of this.checklistRegister.steps) {
						if (!step.id || step.id == '') {
							step.id = res.data.step[0];
							res.data.step.shift();
						}
					}
					this.NotificationService.setNotificationMessage(this.labels['lbl_salvo_com_sucesso']);
				},
				error: () => {
					this.NotificationService.setNotificationMessage(this.labels['lbl_erro_tente_novamente']);
				},
			})
			.add(() => {
				this.isUpdatingChecklist = false;
			});
	}

	deleteChecklist(): void {
		if (this.isUpdatingChecklist == true || this.isDeletingChecklist == true) return;

		this.isDeletingChecklist = true;
		this.ChecklistRegisterPageService.deleteChecklist(this.checklistRegister.id)
			.subscribe({
				next: () => {
					this.NotificationService.setNotificationMessage(this.labels['lbl_geral_deletado_com_sucesso']);
					this.Router.navigate(['/checklist']);
				},
			})
			.add(() => {
				this.isDeletingChecklist = false;
			});
	}

	checkFormValues(): boolean {
		let invalidForm = false;
		let emptyField = false;
		if (this.checklistRegister.checklist_topic == undefined) {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'checklist_topic';
			}).alert = true;
			invalidForm = true;
			emptyField = true;
		}

		if (this.checklistRegister.expirationTime.toString() == '') {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'expirationTime';
			}).alert = true;
			invalidForm = true;
			emptyField = true;
		}

		if (this.checklistRegister.expirationTime < 30) {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'expirationTime';
			}).alert = true;
			invalidForm = true;
			this.NotificationService.setNotificationMessage(this.labels['lbl_tempo_expiracao_minimo_30_minutos']);
		}

		if (this.checklistRegister.expirationTime % 15 != 0) {
			const expirationTimeField = this.generalInformationForm.find((formItem) => {
				return formItem.name == 'expirationTime';
			});
			expirationTimeField.alert = true;
			invalidForm = true;
			this.NotificationService.setNotificationMessage(
				this.labels['lbl_valor_campo_multiplo_de']
					.replace('§_field_§', this.labels[expirationTimeField.label])
					.replace('§_value_§', '15')
			);
		}

		if (this.checklistRegister.name == '') {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'name';
			}).alert = true;
			invalidForm = true;
			emptyField = true;
		}

		if (
			this.checklistRegister.periodicity.split(' ').find((p) => {
				return p == '';
			}) != undefined
		) {
			const index = this.checklistRegister.periodicity.split(' ').indexOf(
				this.checklistRegister.periodicity.split(' ').find((p) => {
					return p == '';
				})
			);
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'periodicity';
			}).alert = index + 1;
			invalidForm = true;
			emptyField = true;
		}

		if (
			this.checklistRegister.periodicity.split(' ')[0] == '*' ||
			Number.parseInt(this.checklistRegister.periodicity.split(' ')[0]) % 15 != 0
		) {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'periodicity';
			}).alert = 1;
			invalidForm = true;
			this.NotificationService.setNotificationMessage(
				this.labels['lbl_valor_campo_nao_pode_ser']
					.replace(
						'§_field_§',
						`${this.labels['lbl_geral_periodicidade']} (${this.labels['lbl_geral_minuto'].charAt(0).toUpperCase() + this.labels['lbl_geral_minuto'].slice(1)})`
					)
					.replace('§_value_§', "'" + this.checklistRegister.periodicity.split(' ')[0] + "'")
			);
		}

		if (this.checklistRegister.periodicity.split(' ')[0].split(',').length > 1) {
			const minuteInput = this.checklistRegister.periodicity.split(' ')[0].split(',');
			const previousValue = minuteInput[0];
			for (const minute of minuteInput) {
				if (
					minute != previousValue &&
					Number.parseInt(minute) - Number.parseInt(previousValue) < this.checklistRegister.expirationTime
				) {
					this.NotificationService.setNotificationMessage(this.labels['lbl_intervalo_minutos_menor_expiracao']);
				}
			}
		}

		if (this.checklistRegister.enduser == undefined) {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'enduser';
			}).alert = true;
			invalidForm = true;
			emptyField = true;
		}

		if (this.checklistRegister.solution_area == undefined) {
			this.generalInformationForm.find((formItem) => {
				return formItem.name == 'solution_area';
			}).alert = true;
			invalidForm = true;
			emptyField = true;
		}

		for (const [index, step] of this.checklistRegister.steps.entries()) {
			if (step.name == '') {
				this.procedureForm[index].find((formItem) => {
					return formItem.name == 'name';
				}).alert = true;
				invalidForm = true;
				emptyField = true;
			}

			if (step.procedure == '') {
				this.procedureForm[index].find((formItem) => {
					return formItem.name == 'procedure';
				}).alert = true;
				invalidForm = true;
				emptyField = true;
			}
		}

		if (emptyField == true) this.NotificationService.setNotificationMessage(this.labels['lbl_preencha_todos_asteriscos']);

		return !invalidForm;
	}
}
